import type { FC } from 'react';
import { Accordion, Flex } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { useCustomerGeoLocationStore } from '../../../bff-api/stores/useCustomerGeoLocationStore';
import { Email } from '../email';
import { FindUs } from '../find-us';
import {
    AccordionAboutLinks,
    AccordionCustomerServiceLinks,
    AccordionExperienceLinks,
} from '../link-groups';
import { Social } from '../social';
import { FooterStore } from '../store/FooterStore';

export const FooterTabletSmall: FC = () => {
    const { data } = useCustomerGeoLocationStore();
    const intl = useIntl();

    return (
        <div data-testid="footer-tablet-small-container" className="flex h-full w-full flex-col">
            <Flex gap={2}>
                <FooterStore
                    id="footer"
                    store={data}
                    title={intl
                        .formatMessage({
                            id: 'nearest.store',
                            defaultMessage: 'Nearest Store',
                        })
                        .toUpperCase()}
                />

                <div className="flex flex-col gap-8">
                    <FindUs />
                    <Social />
                </div>

                <Email />
            </Flex>

            <Accordion allowToggle marginTop="12" borderBottom="1px solid #CCC">
                <AccordionExperienceLinks />
                <AccordionCustomerServiceLinks />
                <AccordionAboutLinks />
            </Accordion>
        </div>
    );
};
